export default "__VITE_ASSET__CMSh5D5z__"